import { Injectable } from '@angular/core';

import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';

// import { ProfileSurvey } from '../../class/profile-survey'; ESTO ESTABA EN EL SERVICIO DEL PROFILE SURVEY

@Injectable()
export class ProfessionService extends WebService {
    public getProfession (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        // params.append('_with', String('profile_survey_new_field.responsabilities.activities'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/professions?${params}`, options);
    }

    public newProfession(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/professions`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateProfession(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/professions/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteProfession(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/professions/${id}`, { headers: this.headers } );
    }

    public infoProfession(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/professions?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/profession/profession.service.ts